import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7eb0b532"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "combined-td-product"
};
const _hoisted_2 = {
  class: "combined-product-box"
};
const _hoisted_3 = {
  class: "custom-img-wrapper"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  key: 1,
  class: "product-sku-asin-text"
};
const _hoisted_6 = {
  class: "combined-product-box"
};
const _hoisted_7 = {
  class: "product-asin-sku-all"
};
const _hoisted_8 = {
  class: "product-asin-sku"
};
const _hoisted_9 = {
  class: "product-asin-sku-only is-hovering"
};
const _hoisted_10 = {
  class: "content-box"
};
const _hoisted_11 = {
  class: "text-content"
};
const _hoisted_12 = {
  key: 0,
  class: "product-title-text-style"
};
const _hoisted_13 = {
  class: "status-item"
};
const _hoisted_14 = {
  class: "product-asin-sku-only"
};
const _hoisted_15 = {
  class: "country-asin-flexbox"
};
const _hoisted_16 = {
  class: "product-sku-asin-text"
};
const _hoisted_17 = {
  key: 0,
  style: {
    "position": "relative"
  },
  class: "ellipsis-2"
};
const _hoisted_18 = {
  key: 1,
  class: "sku-not-found"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1));
const _hoisted_20 = {
  style: {
    "position": "relative"
  },
  class: "ellipsis-2"
};
const _hoisted_21 = {
  key: 0,
  class: "inactive-tag"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_img = _resolveComponent("b-img");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_WrapWithCopy = _resolveComponent("WrapWithCopy");
  const _component_wrap_with_status_icon = _resolveComponent("wrap-with-status-icon");
  const _component_app_td = _resolveComponent("app-td");
  return _openBlock(), _createBlock(_component_app_td, {
    align: "center",
    id: "name-column",
    class: "border-table-row",
    stickyColumn: "true",
    style: _normalizeStyle({
      left: $props.showCheckBox ? '42px' : '1px'
    })
  }, {
    default: _withCtx(() => [_createVNode(_component_wrap_with_status_icon, {
      validationStatus: $props.item.product_name_style.validationStatus,
      hugStyles: {
        padding: '4px 8px 4px 4px'
      },
      status: $props.item.product_name_style.status,
      class: _normalizeClass({
        notHoverable: $data.cellNotHoverable
      }),
      id: $props.uid,
      onClick: _cache[3] || (_cache[3] = () => {
        if (!$data.cellNotHoverable) {
          _ctx.$emit('onEdit', {
            item: $props.item,
            type: 'product_name',
            title: 'Title'
          });
        }
      })
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "image-with-overlay",
        onMouseover: _cache[1] || (_cache[1] = (...args) => $options.preventCellHover && $options.preventCellHover(...args)),
        onMouseleave: _cache[2] || (_cache[2] = (...args) => $options.allowCellHover && $options.allowCellHover(...args))
      }, [_createVNode(_component_app_icon, {
        onClick: _cache[0] || (_cache[0] = $event => $options.onImageChange($props.item)),
        class: "navigation-btn",
        icon: "navigation-button",
        size: "16"
      }), _createVNode(_component_b_img, {
        src: $props.item?.image_small || '/assets/images/amazon-logo-transparent.svg',
        alt: "Image",
        class: "custom-img",
        style: _normalizeStyle({
          width: $data.imgWidth,
          height: $data.imgHeight
        })
      }, null, 8, ["src", "style"]), $props.item.flag ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "country-flag",
        src: $props.item.flag,
        alt: $props.item.country
      }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($props.item.country), 1))], 32)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("p", {
        class: "ellipsis ellipsis-2 title",
        style: _normalizeStyle($props.item.product_name_style.style)
      }, [$props.item.product_name !== null && typeof $props.item.product_name !== 'undefined' && $props.item.product_name.trim() != '' ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($props.item.product_name), 1)) : _createCommentVNode("", true)], 4), $props.item.product_name_style.status != 'unknown' && $props.index == 0 ? (_openBlock(), _createBlock(_component_app_popover, {
        key: 0,
        target: $props.uid,
        "auto-width": "",
        placement: "top",
        "custom-class": `${$props.item.product_name_style.status} ${!$props.showPopover ? 'hide-popover' : ''}`
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", null, _toDisplayString($props.item.product_name_style.tooltipText), 1)])]),
        _: 1
      }, 8, ["target", "custom-class"])) : _createCommentVNode("", true), !$props.item.sku ? (_openBlock(), _createBlock(_component_app_popover, {
        key: 1,
        target: $props.uid,
        "auto-width": "",
        placement: "top",
        "custom-class": `not-editable ${!$props.showPopover ? 'hide-popover' : ''}`
      }, {
        default: _withCtx(() => [_createTextVNode(" Assign SKU to the item to start editing the content ")]),
        _: 1
      }, 8, ["target", "custom-class"])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [$props.item.sku ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_WrapWithCopy, {
        onMouseover: $options.preventCellHover,
        onMouseleave: $options.allowCellHover
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.item.sku), 1)]),
        _: 1
      }, 8, ["onMouseover", "onMouseleave"])])) : (_openBlock(), _createElementBlock("div", _hoisted_18, "SKU not found")), _hoisted_19, _createElementVNode("div", _hoisted_20, [_createVNode(_component_WrapWithCopy, {
        onMouseover: $options.preventCellHover,
        onMouseleave: $options.allowCellHover
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.item.asin), 1)]),
        _: 1
      }, 8, ["onMouseover", "onMouseleave"])])])])])]), $props.item.listing_status === 'Inactive' ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Inactive ")) : _createCommentVNode("", true)])])])]),
      _: 1
    }, 8, ["validationStatus", "status", "class", "id"])]),
    _: 1
  }, 8, ["style"]);
}